import api from "@/api";

export default {
    namespaced: true,

    actions: {

        async fetchAvailableUserActions(context) {
            const url = `/admin/users/action-types`
            const response = await api.request("get", url);
            return response.data;
        },

        async fetchUserActions(context, {page, s, action, include_admins, count_per_page}) {
            const url = `/admin/users/actions?page=${page}&action=${action}&s=${s}&include_admins=${include_admins}&count_per_page=${count_per_page}`
            const response = await api.request("get", url);
            return response.data;
        },
    }
}
